module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-container"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding": "5px 0"
    }
  }, [_c('h1', {
    staticClass: "m-name"
  }, [_vm._v("[" + _vm._s(_vm.tutor.id) + "] " + _vm._s(_vm.tutor.f_name) + " " + _vm._s(_vm.tutor.l_name) + "(" + _vm._s(_vm.tutor.f_name_kana) + " " + _vm._s(_vm.tutor.l_name_kana) + ") 様")]), _vm._v(" "), _c('div', {
    staticClass: "mediumForm"
  }, [_c('ul', _vm._l((_vm.tutor.tutor_channels), function(list, index) {
    return _c('li', {
      key: index,
      staticClass: "medium-list"
    }, [(list.channel) ? [_c('span', [_vm._v(_vm._s(list.channel.name))])] : _vm._e()], 2)
  }), 0)])]), _vm._v(" "), _c('section-navi', [_c('section-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'tutorindex',
        params: {
          id: _vm.tutor.id
        },
        exact: true
      },
      "exact": ""
    }
  }, [_vm._v("データ")])], 1), _vm._v(" "), _c('section-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'tutormedium',
        params: {
          id: _vm.tutor.id
        },
        exact: true
      }
    }
  }, [_vm._v("媒体")])], 1), _vm._v(" "), _c('section-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.getGeo($event)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'tutormap',
        params: {
          id: _vm.tutor.id
        },
        exact: true
      }
    }
  }, [_vm._v("地図")])], 1), _vm._v(" "), _c('section-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'tutorhistory',
        params: {
          id: _vm.tutor.id
        },
        exact: true
      }
    }
  }, [_vm._v("対応履歴")])], 1), _vm._v(" "), _c('section-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'tutorfileview',
        params: {
          id: _vm.tutor.id
        },
        exact: true
      }
    }
  }, [_vm._v("先生ファイル")])], 1), _vm._v(" "), _c('section-item', [_c('tutor-modal', {
    attrs: {
      "tutor": _vm.tutor
    }
  })], 1)], 1), _vm._v(" "), _c('router-view', {
    attrs: {
      "tutor": _vm.tutor,
      "condition": _vm.condition,
      "edit_id": _vm.edit_id
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-636ba96e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Tutor/Tutor.vue
// module id = 1394
// module chunks = 0